import React from 'react'

const History = ({title}) => {
  return (
    <div className="history">
      <div className="container">
        <h3>HISTORY</h3>
          <hr />
        <div className="history-content">
          <p style={{textAlign:"justify"}}>The Sports & Youth Welfare department is one of the transferred subjects of Bodoland Territorial Council. After creation of BTC in the year 2003 with 4 (Four) districts and 10 (Ten) sub divisions is now governed by elected Body with its head Quarter at Kokrajhar and implementing various developmental schemes in an accelerated manner.
          </p>
          <p>It is mentioned here that as per the para “F” of the Office Memorandum No. TAD/BTC/222/03/51 dtd. Dispur the 16th October, 2004 in respect of transferred subjects the department of Sports & Youth Welfare is being run by CHD, Sports & Youth Welfare, BTC for the greater interest of games & sports as well as in the field of development of human resources in BTC area.</p>
        </div>

      </div>
    </div>
  )
}

export default History